import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserRoleService } from '../services/role.service';
import { UserInactiveService } from '../services/user-inactive.service';

@Injectable({
  providedIn: 'root'
})
export class UserInactiveGuard implements CanActivate {

  constructor(
    private userRoleService: UserRoleService,
    private userInactiveService: UserInactiveService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (this.userInactiveService.wasRedirectedByInterceptor()) {
      return of(true);
    }
    return this.userRoleService.getCurrentUser().pipe(
      map(user => {
        if (user && !user.isActive) {
          return true;
        } else {
          return this.router.parseUrl('/home');
        }
      }),
      catchError(error => {
        return of(this.router.parseUrl('/home'));
      })
    );
  }
}
